import React, { useState, useEffect } from "react";
import { Container } from "reactstrap";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import classes from "../style.module.css";
import { MdArrowBackIos, MdArrowForwardIos } from "react-icons/md";
import { Rating } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import ProductDetailTabs from "./ProductDetailTabs";
import { useLocation } from "react-router-dom";
import config from "../../../../config.json";
import toast from "react-hot-toast";
import { getServices } from "../../../../apiServices/apiServices";
import NoInternetComp from "../../InternetConnetction/NoInternetComp";

function ProductDetailView() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [sliderRef, setSliderRef] = useState(null);
  const [data, setData] = useState();
  const [ratingsData, setRatingsData] = useState();
  const location = useLocation();
  const { product_id } = location.state;
  const url = config.url;
  const access_token = sessionStorage.getItem("access-token");

  const [variation, setVariation] = useState(); // selected color
  const [sizeSelection, setSizeSelection] = useState(); // selected size
  const [colorId, setColorId] = useState();
  const [sizeId, setSizeId] = useState();

  const images = sizeSelection?.image || [];
  const slidesToShow = images.length > 4 ? 4 : images.length || 1;

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow,
    slidesToScroll: 1,
    arrows: false,
    beforeChange: (current, next) => setCurrentImageIndex(next),
  };

  useEffect(() => {
    if (navigator.onLine) {
      fetchDeatils();
      fetchRatings();
    }
  }, [navigator]);

  const fetchDeatils = async () => {
    try {
      const res = await getServices(`/api/products/details/${product_id}`);
      if (res.responseCode === 200) {
        const product = res.responseData;
        setData(product);

        const firstColor = product.productColorInfo?.[0] || null;
        setVariation(firstColor);
        setColorId(firstColor?.product_color_id);

        const firstSize = firstColor?.productDataInfo?.[0] || null;
        setSizeSelection(firstSize);
        setSizeId(firstSize?.product_data_id);
        setCurrentImageIndex(0);
      } else {
        toast.error(res.responseMessage);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  const fetchRatings = async () => {
    try {
      const res = await getServices(
        `/api/review/list_review/${product_id}`,
        access_token
      );
      if (res.responseCode === 200) {
        setRatingsData(res.responseData);
      }
    } catch (error) {
      toast.error(error);
    }
  };

  // COLOR CLICK – pick color, reset size
  const handleVariationClick = (color) => {
    setVariation(color);
    setColorId(color.product_color_id);

    const firstSize = color.productDataInfo?.[0] || null;
    setSizeSelection(firstSize);
    setSizeId(firstSize?.product_data_id);
    setCurrentImageIndex(0);
  };

  // SIZE CLICK – pick size
  const handleSizeClick = (size) => {
    setSizeSelection(size);
    setSizeId(size.product_data_id);
    setCurrentImageIndex(0);
  };

  return (
    <>
      {navigator.onLine ? (
        <Container>
          <p className="p-8 text-2xl font-semibold">Product Detail</p>
          <Container className="bg-white mx-4 py-8 mb-8 rounded-3xl shadow-2xl">
            <Container className="flex flex-col md:flex-row ">
              {/* LEFT: IMAGES */}
              <Container className="w-full md:w-2/4 relative md:mx-5">
                <Container className="outline-none border-none rounded mb-3 mx-3 ">
                  {data && images[currentImageIndex] && (
                    <img
                      src={url + images[currentImageIndex]}
                      alt="preview"
                      className="rounded-2xl object-cove w-full h-72 sm:h-[450px]"
                    />
                  )}
                </Container>
                <div
                  style={{
                    backgroundColor: "#161c247a",
                    color: "#ffffff",
                    display: "inline-flex",
                    alignItems: "center",
                    borderRadius: "8px",
                    padding: "2px",
                    position: "absolute",
                    top: "25px",
                    left: "40px",
                  }}
                >
                  <button
                    onClick={sliderRef?.slickPrev}
                    className="px-2 outline-none border-none"
                  >
                    <MdArrowBackIos />
                  </button>
                  {currentImageIndex + 1} / {images.length || 0}
                  <button
                    onClick={sliderRef?.slickNext}
                    className="px-2 outline-none border-none"
                  >
                    <MdArrowForwardIos />
                  </button>
                </div>
                <Slider
                  {...settings}
                  ref={setSliderRef}
                  className="mb-10 max-w-xs mx-auto"
                >
                  {images.map((item, index) => (
                    <div
                      key={index}
                      className={`${classes.thumbnail} outline-none w-full`}
                      onClick={() => setCurrentImageIndex(index)}
                    >
                      <img
                        src={url + item}
                        alt={`Thumbnail ${index + 1}`}
                        className={`${
                          currentImageIndex === index ? classes.active : ""
                        } object-cover`}
                        style={{
                          height: "60px",
                          width: "80px",
                          borderRadius: "16px",
                        }}
                      />
                    </div>
                  ))}
                </Slider>
              </Container>

              {/* RIGHT: DETAILS */}
              <Container className="w-4/5 md:w-2/4 mx-8 my-4">
                <Container className="flex flex-col gap-4 items-start">
                  {data && (
                    <h1 className="font-bold text-xl capitalize">
                      {data?.product_name}
                    </h1>
                  )}

                  {ratingsData?.noOfRatings > 0 && (
                    <Container className="flex items-center">
                      <Rating
                        name="half-rating-read"
                        value={ratingsData ? ratingsData.totalRatings : 0}
                        precision={0.1}
                        readOnly
                        sx={{ color: "#faaf00" }}
                        emptyIcon={<StarIcon style={{ opacity: 0.55 }} />}
                        className="mr-3"
                      />
                      <p style={{ color: "#919eab" }} className="text-sm">
                        ({ratingsData?.noOfRatings} reviews)
                      </p>
                    </Container>
                  )}

                  {/* PRICE */}
                  <Container className="flex items-end">
                    {data && (
                      <h1
                        className="text-3xl font-bold"
                        style={{
                          marginRight:
                            sizeSelection?.sales_price == 0 ? "0" : "1rem",
                        }}
                      >
                        {sizeSelection?.sales_price == 0
                          ? null
                          : "₹ " + sizeSelection?.sales_price}
                      </h1>
                    )}
                    {data && (
                      <h1
                        className="text-xl font-bold"
                        style={{
                          color:
                            sizeSelection?.sales_price == 0
                              ? "#353535"
                              : "#64748B",
                          fontSize:
                            sizeSelection?.sales_price == 0
                              ? "1.875rem"
                              : "1.25rem",
                          lineHeight: sizeSelection?.sales_price
                            ? "1.75rem"
                            : "2.25rem",
                        }}
                      >
                        {sizeSelection?.sales_price == 0 ? (
                          "₹ " + sizeSelection?.price
                        ) : (
                          <del>{"₹ " + sizeSelection?.price}</del>
                        )}
                      </h1>
                    )}
                  </Container>

                  <p className="text-slate-500 w-full text-justify">
                    {data ? data.description : null}
                  </p>
                  <hr
                    className="m-0 w-full"
                    style={{
                      borderWidth: "0px 0px thin",
                      borderColor: "#00000033",
                      borderStyle: "dashed",
                    }}
                  />

                  {/* CATEGORY */}
                  <Container className="flex justify-between w-full items-start">
                    {data && <h2 className="font-semibold">Category</h2>}
                    <p className="text-right text-sm">
                      {data?.categoryInfo
                        ?.map((category) => category.category_name)
                        ?.join(", ")}
                    </p>
                  </Container>
                  {/* <Container className="flex justify-between w-full items-center">
                    {data?.subcatInfo?.subcat_name && (
                      <h2 className="font-semibold">Sub-Category</h2>
                    )}
                    <p className="text-right">
                      {data?.subcatInfo?.subcat_name}
                    </p>
                  </Container> */}

                  {/* COLOR SELECTION */}
                  <Container className="flex justify-between w-full items-center">
                    <h2 className="font-semibold w-1/3">Colors</h2>
                    <Container className="flex gap-2 flex-wrap items-center text-center">
                      {data?.productColorInfo?.map((clr, idx) => (
                        <Container
                          key={idx}
                          onClick={
                            colorId === clr.product_color_id
                              ? undefined
                              : () => handleVariationClick(clr)
                          }
                          className={`text-center cursor-pointer capitalize rounded-md ${
                            colorId === clr.product_color_id
                              ? "border-2 border-slate-500 opacity-100"
                              : "opacity-50"
                          }`}
                        >
                          <img
                            src={
                              url + (clr.productDataInfo?.[0]?.image?.[0] || "")
                            }
                            alt={clr.colors}
                            className="w-16 rounded-md h-10 object-cover"
                          />
                          <p className="text-xs">{clr.colors}</p>
                        </Container>
                      ))}
                    </Container>
                  </Container>

                  {/* SIZE SELECTION BY BREADTH x LENGTH */}
                  {variation?.productDataInfo &&
                    variation.productDataInfo.length > 0 && (
                      <Container className="bg-[#f1f5f9] p-4 mb-3 rounded mt-2 w-full">
                        <p className="font-semibold text-sm mb-2">
                          Select Size (breadth x length) in cm
                        </p>
                        <Container className="flex flex-wrap gap-2 justify-end">
                          {variation.productDataInfo.map((size) => (
                            <button
                              key={size.product_data_id}
                              onClick={() => handleSizeClick(size)}
                              className={`px-3 py-1 rounded-full text-xs border ${
                                sizeSelection?.product_data_id ===
                                size.product_data_id
                                  ? "bg-[#800000] text-white border-[#800000]"
                                  : "border-slate-300 text-slate-700 bg-white"
                              }`}
                            >
                              {size.breadth_in_mm} x {size.length_in_mm}
                            </button>
                          ))}
                        </Container>
                      </Container>
                    )}

                  {/* SHOW BRANDINGS FOR SELECTED SIZE */}
                  <Container className="flex justify-between w-full items-center">
                    <h2 className="font-semibold w-1/3">Branding name</h2>
                    <Container className="flex gap-2 flex-wrap items-center text-end">
                      {sizeSelection?.brandings?.length > 0 ? (
                        <p className="my-2">
                          {sizeSelection.brandings
                            .map((brand) => brand.name)
                            .join(", ")}
                        </p>
                      ) : (
                        <p className="my-2 text-slate-400">No branding</p>
                      )}
                    </Container>
                  </Container>

                  {/* WEIGHT, SIZE, SKU */}
                  <Container className="flex justify-between w-full items-center">
                    {data && <h2 className="font-semibold">Weight(approx.)</h2>}
                    <Container>
                      {data && (
                        <p className="my-2">{sizeSelection?.weight} kg</p>
                      )}
                    </Container>
                  </Container>
                  <Container className="flex justify-between w-full items-center">
                    {data && (
                      <h2 className="font-semibold">Length X Breadth (cm)</h2>
                    )}
                    <Container>
                      {data && (
                        <p className="my-2">
                          {sizeSelection?.length_in_mm} X{" "}
                          {sizeSelection?.breadth_in_mm}
                        </p>
                      )}
                    </Container>
                  </Container>
                  {sizeSelection?.taxInfo && (
                    <Container className="flex justify-between w-full items-center">
                      {data && (
                        <h2 className="font-semibold">GST info (CGST/SGST)</h2>
                      )}
                      <Container>
                        {data && (
                          <p className="my-2">
                            {sizeSelection?.taxInfo?.tax_name +
                              " (" +
                              sizeSelection?.taxInfo?.cgst +
                              "/" +
                              sizeSelection?.taxInfo?.sgst +
                              ")"}
                          </p>
                        )}
                      </Container>
                    </Container>
                  )}
                  <Container className="flex justify-between w-full items-center">
                    {data && <h2 className="font-semibold">Product SKU</h2>}
                    <Container>
                      {data && (
                        <p className="my-2">{sizeSelection?.product_sku}</p>
                      )}
                    </Container>
                  </Container>

                  <hr
                    className="m-0 w-full"
                    style={{
                      borderWidth: "0px 0px thin",
                      borderColor: "#00000033",
                      borderStyle: "dashed",
                    }}
                  />
                </Container>
              </Container>
            </Container>

            <Container className="mx-8">
              <ProductDetailTabs data={data} ratingsData={ratingsData} />
            </Container>
          </Container>
        </Container>
      ) : (
        <Container className="min-h-[65vh] flex flex-col justify-center items-center">
          <NoInternetComp />
        </Container>
      )}
    </>
  );
}

export default ProductDetailView;
